import { z } from 'zod/v3';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '@cotera/client/v0/actions/framework';
import { ok } from 'neverthrow';
import { ArtifactPanelModel } from '../artifact-panel.model';

const inputSchema = z.object({});

export class ExpandArtifactPanelAction extends BaseAction<
  z.infer<typeof inputSchema>,
  { t: string; message?: string }[]
> {
  title = 'Expand Artifact Panel';
  inputSchema = inputSchema;
  group = 'View';
  description = 'Expand the artifact panel to fill the main view';
  icon = 'arrows-pointing-out';

  applicable(context: ApplicableContext): boolean {
    const model = context.getInScopeModelOfType(ArtifactPanelModel);
    if (model === null) {
      return false;
    }
    return (
      model.canExpandWatchable.snapshot() &&
      !model.isExpandedWatchable.snapshot()
    );
  }

  async execute(
    _params: z.infer<typeof inputSchema>,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    context.getInScopeModelOfType(ArtifactPanelModel)?.expand();
    return ok({});
  }
}
